var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"tk-product-menu-container"},[_c('div',{staticClass:"component-wrapper"},[_vm._t("menu")],2),_vm._t("buttons")],2)}
var staticRenderFns = []

export { render, staticRenderFns }